'use client';

import * as React from 'react';

import { useNotification } from './use-notification';

export type LoginAndSignupModalsContextValue = {
  showUnauthenticatedError: (options?: { consoleMessage?: string }) => void;
  showGenericError: (options?: {
    consoleMessage?: string;
    timeout: number;
  }) => void;
};

interface Props {
  children: React.ReactNode;
}

export const LoginAndSignupModalsProvider: React.FC<Props> = ({ children }) => {
  const { addNotification } = useNotification();

  const contextValue: LoginAndSignupModalsContextValue = {
    showUnauthenticatedError: () => {
      addNotification({
        type: 'error',
        title: 'error',
        message: 'User is unauthenticated',
      });
    },
    showGenericError: (options?: {
      consoleMessage?: string;
      timeout: number;
    }) => {
      addNotification({
        type: 'error',
        title: 'error',
        timeout: options?.timeout,
        message: 'An error occurred',
      });
    },
  };

  return (
    <LoginAndSignupModalsContext.Provider value={contextValue}>
      {children}
    </LoginAndSignupModalsContext.Provider>
  );
};

export const LoginAndSignupModalsContext = React.createContext<
  LoginAndSignupModalsContextValue | undefined
>(undefined);

export const useLoginAndSignupModals = () => {
  const context = React.useContext(LoginAndSignupModalsContext);

  if (context === undefined) {
    throw new Error(
      'useLoginAndSignupModals must be used within a LoginAndSignupModalsProvider'
    );
  }

  return context;
};
